import { render, staticRenderFns } from "./cleanList.vue?vue&type=template&id=22953e73&scoped=true&"
import script from "./cleanList.vue?vue&type=script&lang=js&"
export * from "./cleanList.vue?vue&type=script&lang=js&"
import style0 from "./cleanList.vue?vue&type=style&index=0&id=22953e73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22953e73",
  null
  
)

export default component.exports